const compactFormatter = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });
const integerFormatter = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

/**
 * Formats a numeric value as a compact German Euro string
 * (e.g. "1,5 Mio. €", "850 Tsd. €", "950 €"), max 1 fraction digit.
 * Returns the fallback string when the value is null or undefined.
 *
 * @param {number|string|null|undefined} value - Value to format
 * @param {string} [fallback='–'] - Fallback for null/undefined
 * @returns {string}
 */
export function formatEurCompact(value, fallback = '–') {
	if (value === null || value === undefined) return fallback;
	const num = Number(value);
	if (Math.abs(num) >= 1_000_000) return `${compactFormatter.format(num / 1_000_000)} Mio. €`;
	if (Math.abs(num) >= 1_000) return `${compactFormatter.format(num / 1_000)} Tsd. €`;
	return `${integerFormatter.format(num)} €`;
}

/**
 * Formats a numeric value with German integer grouping (e.g. "12.500").
 * Returns the fallback string when the value is null or undefined.
 *
 * @param {number|string|null|undefined} value - Value to format
 * @param {string} [fallback='–'] - Fallback for null/undefined
 * @returns {string}
 */
export function formatNumber(value, fallback = '–') {
	if (value === null || value === undefined) return fallback;
	return integerFormatter.format(Number(value));
}
